export default class InsightFiltersViewModel {
    public insightName: string = ''
    public agentName: string = ''
    public client: string = ''
    public channel: string = ''
    public schedule: string = ''
    public timePeriod: string = ''
    public weekNumber: string = ''
    public teamManager: string = ''
    public datePreset: string = 'This Month'
    public startDate: Date = new Date()
    public endDate: Date = new Date()
    public pageNumber: number = 1

    constructor(client: string) {
        this.client = client
    }
}